export default {
    subscriptionRequiredMessage:"You need an active subscription to access this content",
    subscriptionPlansTitle:"Subscription plans",
    subscriptionPlansDescription:"Choose the perfect plan for your language learning journey",
    subscriptionLabel:"Subscriptions",
    currentSubscriptionPlanLabel:"Current Plan",
    popularPlanLabel:"Popular",

    subscriptionPromptTitle:"Unlock full access",
    subscriptionPromptDescription:"Choose a plan to keep your practice going",
    subscriptionDaysLabel:"{{dayCount}} days",
    subscriptionPaymentTypeLabel:"one-time",
    subscriptionFreeTrialLabel:"Free Trial",
    subscriptionFreeTrialActionLabel:"Try for free",
    subscriptionPromptPositiveActionLabel:"Get {{subscriptionPlan}}",
    subscriptionPromptNegativeActionLabel:"Maybe later",
    subscriptionPromptFooterNote:"One-time payment. not auto-renewal."
}